import { connect } from 'react-redux';

import { StatusCheck } from './status-check.component';
import { getCampaignStatus } from '../../modules/friends-referral/friends-referral-store';
import { IStatusProps } from './status-check.types';
import { State } from 'widgets/friends-referral/root/root.reducers';

const mapStateToProps = (state: State): IStatusProps => ({
    env: state.config.envName,
    campaignId: state.config.friendsReferral?.campaignId!
});

const mapDispatchToProps = { getCampaignStatus };

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StatusCheck);
